import { createRoot } from 'react-dom/client'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import { authUser } from './common/actions/auth'
import { initLocalize } from 'common/actions/localize'

import configureStore from './utils/configureStore'
import makeRootSaga from './common/sagas'
import Root from './common/components/Root'

import { Amplify } from 'aws-amplify'
import { AWS_COGNITO_USER_POOL_ID, AWS_COGNITO_WEB_CLIENT_ID } from './config'

// Amplify v6 config shape. Region is inferred from the user pool id.
// The v4-only options (mandatorySignIn, authenticationFlowType) were removed;
// USER_SRP_AUTH is the default flow and can be set per signIn call if needed.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: AWS_COGNITO_WEB_CLIENT_ID
    }
  }
})

const store = configureStore({}, browserHistory)
const history = syncHistoryWithStore(browserHistory, store)
store.runSaga(makeRootSaga())

store.dispatch(authUser())
store.dispatch(initLocalize())

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(
  <Root
    store={store}
    history={history}
  />
)

export { store }
